// Portable value/layout estimates, not browser-process heap measurements.
export function valueBytes(value,seen=new Set()){
  if(value===null||value===undefined)return 0
  if(typeof value==='number')return 8
  if(typeof value==='boolean')return 4
  if(typeof value==='string')return value.length*2
  if(typeof value!=='object'||seen.has(value))return 0
  seen.add(value)
  if(value instanceof Date)return 16
  if(ArrayBuffer.isView(value))return value.byteLength
  if(value instanceof ArrayBuffer)return value.byteLength
  if(Array.isArray(value))return 24+value.length*8+value.reduce((sum,item)=>sum+valueBytes(item,seen),0)
  return 32+Object.entries(value).reduce((sum,[key,item])=>sum+key.length*2+8+valueBytes(item,seen),0)
}
export function sourceMetrics(value,computeMs=0){return {computeMs:Math.max(0,computeMs),operations:0,peakBytes:valueBytes(value)}}
export function operationMetrics(before,input,output,computeMs){
  const previous=before||sourceMetrics(input)
  return {computeMs:previous.computeMs+Math.max(0,computeMs),operations:previous.operations+1,peakBytes:Math.max(previous.peakBytes,valueBytes(input)+valueBytes(output))}
}
export function joinedMetrics(items,output,computeMs){
  const profiles=items.map(item=>item.metrics||sourceMetrics(item.value))
  return {computeMs:profiles.reduce((sum,p)=>sum+p.computeMs,0)+Math.max(0,computeMs),operations:profiles.reduce((sum,p)=>sum+p.operations,0)+1,peakBytes:Math.max(profiles.reduce((sum,p)=>sum+p.peakBytes,0),items.reduce((sum,item)=>sum+valueBytes(item.value),0)+valueBytes(output))}
}
export function resourceEstimate(map,items,delivered){
  let bytes=0,machines=0,belts=0,slots=0
  for(const b of map.values()){
    const rows=b.rows||1;slots+=rows
    if(b.type==='belt'){belts++;bytes+=64}else{machines++;bytes+=128+rows*16+valueBytes(b.args)}
    for(const input of b.inputs||[])if(input)bytes+=48+valueBytes(input.value)
  }
  bytes+=items.reduce((sum,item)=>sum+64+valueBytes(item.value),0)
  bytes+=delivered?.metrics?.peakBytes||valueBytes(delivered?.value)
  return {bytes,machines,belts,slots}
}
export function durationText(ms){
  const seconds=Math.max(0,Math.floor(ms/1000)),minutes=Math.floor(seconds/60),hours=Math.floor(minutes/60)
  return hours?hours+'时 '+minutes%60+'分 '+seconds%60+'秒':minutes+'分 '+seconds%60+'秒'
}
export function computeText(ms){return ms<0.001?'< 0.001 ms':ms.toFixed(3)+' ms'}
export function bytesText(bytes){return bytes<1048576?(bytes/1024).toFixed(2)+' KB':(bytes/1048576).toFixed(2)+' MB'}
export function codeBytes(code){let bytes=0;for(const ch of String(code)){const point=ch.codePointAt(0);bytes+=point<=0x7f?1:point<=0x7ff?2:point<=0xffff?3:4}return bytes}
